export function useFootnoteOpenState() {
  const openState = reactive(new Map<string, boolean>())

  return {
    openState,
    open: (id: string) => openState.set(id, true),
    close: (id: string) => openState.set(id, false),
    isOpen: (id: string) => openState.get(id) ?? false,
  }
}
